type NavLinkProps = {
  currentPath: string;
  href: string;
  label: string;
};

export function NavLink({ currentPath, href, label }: NavLinkProps) {
  const active = currentPath === href || (href === "/go" && currentPath === "/");

  return (
    <a className={active ? "activeNav" : undefined} href={href}>
      {label}
    </a>
  );
}

